import { Button, IconButton, Typography } from "@mui/material";
import React, { useContext } from "react";
import AddIcon from "@mui/icons-material/Add";
import { createColumnHelper } from "@tanstack/react-table";
import DeleteIcon from "../../../assets/images/Icons/TrashIcon.png";
import { CustomeDialog, CustomTable, DeleteModal } from "../../../shared";
import { TemplateStoreSelectDialog } from "../../../shared/components/TemplateStoreSelectDialog";
import { RegenerateDialog } from "./RegenerateDialog";
import { AuthContext } from "../../../store";

export const TemplateStoreList = (props) => {
  const {
    dialogBoxId,
    state,
    setState,
    assignedStoreState,
    handleModal,
    handleStoreDialogSelect,
    handleStoreToRecipe,
    onSearchHandler,
    assingedStoreListQueryTemplate,
    confirmDeleteStrores,
    storesDeleteInfo,
    handleDeleteStores,
    clearStoresDeleteInfo,
    templates,
    handleAlertClickOpen,
    onChangeStoreEffectiveDate,
    handleStoreDeleteDialog,
    isStoreAdmin,
    onChangeEffectiveDates,
    isStoreAssign,
    isEditable,
  } = props;

  const {
    auth: {
      data: { stores, selectedStoreId },
    },
  } = useContext(AuthContext);

  const { isOpenStoreDialog, selectedStores, alreadySelectedStores } =
    state.selectStoreDialogDetails;

  const handleOnSubmit = () => {
    handleStoreToRecipe();
    handleAlertClickOpen(false, dialogBoxId);
  };

  const columnHelper = createColumnHelper(
    assignedStoreState?.assignedStoreList
  );
  const columns = [
    columnHelper.accessor((row) => row.state || row.storename || "", {
      id: "storeOrState",
      header: "Store Name",
      enableSorting: true,
      cell: (props) => {
        const { row } = props;
        if (row.depth === 0) {
          return (
            <Typography
              sx={{
                color: "primary.main",
                textTransform: "uppercase",
              }}
            >
              {row.original.state}
            </Typography>
          );
        } else if (row.depth === 1) {
          return <Typography>{row.original.storename}</Typography>;
        }
        return null;
      },
    }),
    columnHelper.display({
      id: "actions",
      cell: (props) => {
        const { row } = props;

        return row.depth && isStoreAdminDelete(row.original.id)
          ? isEditable && (
              <IconButton
                onClick={(e) => {
                  handleStoreDeleteDialog(true, row.original.id);
                }}
                disabled={selectedStoreId === row.original.id}
                size="small"
              >
                <img src={DeleteIcon} alt="Delete" />
              </IconButton>
            )
          : "";
      },
    }),
  ];

  function isStoreAdminDelete(id) {
    if (!isStoreAdmin) {
      return true;
    }
    return stores.some((v) => v.id === id);
  }

  return (
    <>
      <CustomTable
        defaultData={assignedStoreState?.assignedStoreList}
        columns={columns}
        allRowsExpanded={true}
        customRowStyle={(row) => (!row.depth ? { borderBottom: "none" } : null)}
        headerText="Assigned Store"
        subRow="subRows"
        search={assignedStoreState?.search}
        onSearchChange={onSearchHandler}
        manualFiltering={true}
        emptyTableMessage="No stores added yet!."
        rightContent={
          isStoreAssign && (
            <Button
              type="button"
              color="gray"
              variant="outlined"
              size="small"
              onClick={() => handleModal("store-dialog-add", true)}
              startIcon={<AddIcon />}
            >
              Store
            </Button>
          )
        }
        enableTableContainerPaddingBottom
        tableStyle={{ px: "16px" }}
        tableHeaderStyles={{ fontSize: "18px", fontWeight: 500, px: 0 }}
      />

      <CustomeDialog
        open={isOpenStoreDialog}
        PaperProps={{
          sx: {
            width: { sm: "340px", xs: "90%" },
            maxHeight: "90vh",
            minHeight: "400px",
          },
        }}
        isHeader={false}
        content={
          <TemplateStoreSelectDialog
            templates={state}
            onChangeStoreEffectiveDate={onChangeStoreEffectiveDate}
            setTemplates={setState}
            selectedStores={selectedStores}
            alreadySelectedStores={alreadySelectedStores}
            onSelect={handleStoreDialogSelect}
            disabled={selectedStores.length === 0}
            isSelected={(id) => selectedStores.includes(id)}
            onSubmit={handleOnSubmit}
            open={templates?.isStoreOpen}
            handleClickOpen={handleAlertClickOpen}
            handleClose={() => handleModal("store-dialog-add", false)}
            assignedStoreState={assignedStoreState}
            id={dialogBoxId}
            assingedStoreListQueryTemplate={
              assingedStoreListQueryTemplate?.data
            }
          />
        }
      />
      <DeleteModal
        open={storesDeleteInfo?.show}
        handleClose={clearStoresDeleteInfo}
        onConfirm={confirmDeleteStrores}
      />
      <CustomeDialog
        PaperProps={{
          sx: {
            minWidth: "570px",
            minHeight: "280px",
          },
        }}
        open={state?.isOpen}
        title={
          <Typography
            sx={{
              padding: "20px 20px 8px 20px",
              fontWeight: "500",
              fontSize: "20px",
              width: "100%",
            }}
          >
            From when should this template change be applied to generated
            production charts?
          </Typography>
        }
        content={
          <RegenerateDialog
            onSubmit={handleDeleteStores}
            templates={state}
            onChangeEffectiveDate={onChangeEffectiveDates}
            setTemplates={setState}
            handleClose={() => handleStoreDeleteDialog(false)}
            state={state}
          />
        }
      />
    </>
  );
};
